import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import {SingleValue} from 'react-select';
import InputSelect from '../../../../common/components/ui/InputSelect';
import {recurringPeriodsEn, recurringPeriodsHe} from '../../../../common/enums';
import './CustomInputSelectStyles.scss';
import {shallowEqual, useSelector} from 'react-redux';
import {RootState} from '../../../../store/configureStore';
import styles from './FieldRecurringPeriod.module.scss';

type Option = { label: string, value: number };

const FieldRecurringPeriod = () => {
  const [field, meta, helpersStatus] = useField({name: 'recurringPeriod'});
  const intl = useIntl();
  const placeholderLabel = intl.formatMessage({
    id: 'payment-recurring-period-label', defaultMessage: 'Recurring period'
  });

  const handleChange = (option: SingleValue<Option>) => {
    helpersStatus.setValue(option?.value || recurringPeriods['1']);
  };
  const currentLocale = useSelector((state: RootState) => state.i18n.locale, shallowEqual);
  const recurringPeriods = currentLocale === 'he' ? recurringPeriodsHe : recurringPeriodsEn;
  const [selectedValue] = recurringPeriods.filter(option => option.value === field.value);

  return (
    <div className={styles.selectContainer}>
      <InputSelect
        <Option>
        {...field}
        {...meta}
        id={field.name}
        label={placeholderLabel}
        placeholder={placeholderLabel}
        value={selectedValue}
        options={recurringPeriods}
        onChange={handleChange}
        isClearable={false}
        isSearchable={false}
      />
    </div>
  );
};

export default FieldRecurringPeriod;
